export const base64EncodeUtf8 = async (input: string): Promise<string> => {
  const encoder = new TextEncoder();
  const data = encoder.encode(input);
  const blob = new Blob([data]);
  const base64 = await blobToBase64(blob);
  return base64;
};

export const base64DecodeUtf8 = async (base64: string): Promise<string> => {
  const blob = base64ToBlob(base64);
  const decoded = await blob.text(); // Read it as UTF-8 string
  return decoded;
};

export const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = (reader.result as string).split(",")[1];
      resolve(base64String);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const base64ToBlob = (base64: string): Blob => {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new Blob([bytes], { type: "text/plain;charset=utf-8" });
};
